import { Observable } from 'rxjs';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';

export abstract class NotificacionCorreoService {
  abstract guardarCorreoNotificacion(correo: string, telefono: number, tipoNotificacion: string): Observable<GeneralResponse<any>>;
}
